export default __webpack_public_path__ + "static/13-d5c966b7e27ea5ebb5f3755aff8e840e.png";